import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";
import Icon from "@ant-design/icons";

export default function Navbar() {
  let location = useLocation();

  React.useEffect(() => {}, [location]);

  return (
    <Layout className="layout">
      <Menu
        mode="horizontal"
        selectedKeys={window.location.hash.slice(2)}
        items={[
          {
            key: "",
            // label: (
            //   <Link to="/">
            //     <b>VCAT</b>
            //   </Link>
            // ),
            label: (
              <Link to="/">
                <Icon
                  component={() => (
                    <img
                      style={{
                        height: "2rem",
                        transform: "translateY(0.55rem)",
                      }}
                      src={process.env.PUBLIC_URL + "/imgs/logo-inline.png"}
                    />
                  )}
                />
              </Link>
            ),
          },
          {
            key: "dashboard",
            label: <Link to="/dashboard">Dashboard</Link>,
          },
          {
            key: "extraction",
            label: <Link to="/extraction">Extraction</Link>,
          },
          {
            key: "about",
            label: <Link to="/about">About</Link>,
          },
        ]}
      />
    </Layout>
  );
}
